import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {MxMaterialModule} from '../../material/mx-material.module';
import {MxButtonModule} from '../mx-button/mx-button.module';
import {MxConfirmDialogComponent} from './components/mx-confirm-dialog/mx-confirm-dialog.component';
import {MxErrorDialogComponent} from './components/mx-error-dialog/mx-error-dialog.component';
import {MxReportUrlDialogComponent} from './components/mx-report-url-dialog/mx-report-url-dialog.component';
import {
    MxGraphAdvancedFiltersDialogComponent
} from "./components/mx-graph-advanced-filters/mx-graph-advanced-filters-dialog.component";
import {MxFormModule} from "../mx-form/mx-form.module";
import {MxSharedModule} from '../../shared/mx-shared.module';

@NgModule({
    imports: [
        CommonModule,
        MxMaterialModule,
        MxButtonModule,
        TranslateModule,
        MxFormModule,
        MxSharedModule
    ],
    declarations: [
        MxConfirmDialogComponent,
        MxGraphAdvancedFiltersDialogComponent,
        MxErrorDialogComponent,
        MxReportUrlDialogComponent
    ],
    exports: [
        MxConfirmDialogComponent,
        MxGraphAdvancedFiltersDialogComponent,
        MxErrorDialogComponent,
        MxReportUrlDialogComponent
    ]
})
export class MxDialogsModule {
}
